import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

import type { MatchHudLayout } from "../alpha/hud/hud-layout";
import {
  createPhysicalSceneSnapshot,
  type PhysicalSceneSnapshot,
} from "./scene-diagnostics-snapshot";

interface TestSceneDiagnosticsApi {
  readonly snapshot: () => PhysicalSceneSnapshot;
}

declare global {
  interface Window {
    __FATE_PHYSICAL_SCENE__?: TestSceneDiagnosticsApi;
  }
}

export function SceneDiagnostics3D({ hudLayout }: { readonly hudLayout: MatchHudLayout }) {
  const scene = useThree((state) => state.scene);
  const camera = useThree((state) => state.camera);
  const size = useThree((state) => state.size);

  useEffect(() => {
    if (import.meta.env.MODE !== "test") return;
    const api: TestSceneDiagnosticsApi = {
      snapshot: () =>
        createPhysicalSceneSnapshot(scene, camera, {
          viewportWidth: size.width,
          viewportHeight: size.height,
          hudBlockers: [
            ["top-console", hudLayout.topConsole],
            ["status-message", hudLayout.statusMessage],
            ["phase-action", hudLayout.phaseAction],
          ],
        }),
    };
    window.__FATE_PHYSICAL_SCENE__ = api;
    return () => {
      if (window.__FATE_PHYSICAL_SCENE__ === api) delete window.__FATE_PHYSICAL_SCENE__;
    };
  }, [camera, hudLayout, scene, size.height, size.width]);

  return null;
}
